"use client";

import React from "react";
import BaseTailoringQuestions, { TailoringQuestion } from "../../shared/BaseTailoringQuestions";

interface PPETailoringQuestionsProps {
  onBack?: () => void;
}

const TAILORING_QUESTIONS: TailoringQuestion[] = [
  {
    id: "PPE-1",
    question: "Does the entity use revaluation model of accounting for any of its classes of property, plant & equipment?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "PPE-2",
    question: "Has the entity capitalized any interest or salary on any asset during the year?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "PPE-3",
    question: "Are there any impairment indicators over the property, plant & equipment during the current year?",
    type: "radio",
    options: ["Yes", "No"]
  },
  {
    id: "PPE-4",
    question: "Does the entity have any self-generated asset/barter exchange during the period apart from capital work-in progress?",
    type: "radio",
    options: ["Yes", "No"]
  }
];

export default function PPETailoringQuestions({ onBack }: PPETailoringQuestionsProps) {
  return (
    <BaseTailoringQuestions
      areaName="Property, Plant & Equipment"
      title="PPE Tailoring Questions"
      description="Customize the audit program with entity-specific questions"
      questions={TAILORING_QUESTIONS}
      onBack={onBack}
    />
  );
}
